module.exports = __webpack_public_path__ + "img/magento-services-integration_medium.329f4bb3.webp";